import { Injectable } from '@angular/core';
import { Filters } from '../../../components/filters/models/filters';
import {Payload} from "../../../services/payload/models/payload";
import {MatomoService} from "../../../services/matomo.service";

@Injectable({
  providedIn: 'root',
})
export class PayloadFactoryService {
  constructor(private matomoService: MatomoService) {}

  createPayload(filters?: Filters): Payload {
    return Payload.create(filters, this.matomoService);
  }
}
